import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootReducer } from 'src/redux/rootReducer'
import { initialFilters, SET_FILTERS } from 'dealer-reducers/src/redux/tableToolsReducer'
import { useTranslation } from 'react-i18next'
import track from 'src/helpers/track'
import JetSkiSvg from '../other/svg/JetSkiSvg'

const JetSkiFilter = (): JSX.Element => {
  const currentTab = useSelector((state: RootReducer) => state.offersListReducer.tab)
  const active = useSelector(
    (state: RootReducer) => state.tableToolsReducer.filters[currentTab].vehicle_type === 'JetSki'
  )
  const dispatch = useDispatch()
  const { t } = useTranslation()
  return (
    <div
      onClick={() => {
        dispatch(SET_FILTERS({ ...initialFilters, vehicle_type: 'JetSki', tab: currentTab }))
        track('dealer_filter_machine_type')
      }}
      className="2xl:px-1.5 2xl:py-0.5 h-6 bg-Estigroup-primary rounded-md flex justify-center items-center gap-1 overflow-hidden cursor-pointer px-4 py-4"
      style={{
        backgroundColor: active ? '#3582CE' : 'white'
      }}>
      <div className="w-6 h-4 relative overflow-hidden">
        <JetSkiSvg style={{ color: active ? 'white' : '#71717A' }} />
      </div>
      <div
        style={{ color: active ? 'white' : '#71717A' }}
        className="justify-start text-foregrounds-fg-on-color text-xs font-medium font-opensans leading-tight hidden 2xl:block">
        {t('JetSki_offers')}
      </div>
    </div>
  )
}

export default JetSkiFilter
